import React from 'react';
import { Link } from 'react-router-dom'; 
import './header.css';
import Logo from "../assets/Stannum10.png";
import { FaPhone, FaEnvelope } from 'react-icons/fa';

export const Header = () => {
  return (
    <div className="navbar">
      <div className="navbar-logo">
        <img className='logo-image' src={Logo} alt="Logo" />
      </div>
      <nav className="navbar-menu">
        <ul className='nav-ul'>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/about">About Us</Link></li>
          <li><Link to="/services">Our Services</Link></li>
          <li><Link to="/vacancy">Career Development</Link></li>
          <li><Link to="/contact">Contact</Link></li>
          <a href="tel:+971505887449" className="navbar-contact">
            <FaPhone className="info-icon" />
          </a>
          <a href="mailto:stannumhrconsultanciesllc@gmail.com" className="navbar-contact">
            <FaEnvelope className="info-icon" />
          </a>
        </ul>
      </nav>
    </div>
  );
};
